import classNames from 'classnames';
import { InputHTMLAttributes } from 'react';

export function DebugInput(props: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input {...props} className={classNames('text-black bg-white px-2 py-1.5 rounded-md', props.className)} />
  )
}
